/**
 *
 * Even though the BE returns an array of Product Tags,
 * the FE only shows the first one in the array. For the Graph,
 * the zero percent tag is already included in the BE response.
 */ const getProductTag = (serverTags)=>{
    if (serverTags[0]) {
        var _key;
        return {
            iconKey: (_key = serverTags[0].key) !== null && _key !== void 0 ? _key : undefined,
            value: serverTags[0].value
        };
    }
    return undefined;
};

export { getProductTag };
//# sourceMappingURL=get-product-tag.js.map
